<template>
  <div class="medication-class">
    <v-select
        :disabled="!isEditable"
        :items="getAvailableItems()"
        :placeholder="computedPlaceholder"
        :error="error"
        v-model="computedValue"
        outlined
        dense
        hide-details
        class="medication-class__select"
    >
      <template v-slot:item="{ item }">
        <span>{{ item.text }}</span>
        <medication-recommendation-tooltip
            v-if="medicationClassHasBeenRecommended(item.value)"
        />
      </template>
      <template v-slot:selection="{ item }">
        <span>{{ item.text }}</span>
        <medication-recommendation-tooltip
            v-if="medicationClassHasBeenRecommended(item.value) && !hideRecommendationInfo"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
import MedicationRecommendationTooltip from "./MedicationRecommendationTooltip";

/**
 * Component MedicationClass.vue
 *
 * @module MedicationClass
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.10] app/src/APP_DASHBOARD/templates/components/Parts/Medication/MedicationClass.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'MedicationClass',
  components: {MedicationRecommendationTooltip},
  props: {
    value: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    error: {
      type: Boolean,
      default: () => false,
    },
    recommendedClasses: {
      type: Array,
      default: () => [],
    },
    selectedClasses: {
      type: Array,
      default: () => [],
    },
    isRecommendation: {
      type: Boolean,
      default: () => false,
    },
    hideRecommendationInfo: {
      type: Boolean,
      default: () => false,
    }
  },
  computed: {
    items() {
      return this.$store.getters['dss/medicationClasses'].map(item => (
              {
                value: item.key,
                text: item.name
              }
          )
      );
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    computedPlaceholder() {
      return this.isEditable ? this.placeholder : '';
    }
  },
  data() {
    return {
    }
  },
  methods: {
    medicationClassHasBeenRecommended(medicationClass) {
      return this.recommendedClasses.some((item) => item.key === medicationClass);
    },
    getAvailableItems() {
      let selectedClassesWithoutCurrentValue = this.selectedClasses.filter((selectedClass) => selectedClass !== this.value && selectedClass !== "")
      if (selectedClassesWithoutCurrentValue.length === 0) {
        return this.items;
      }
      return this.items.filter((item) => !selectedClassesWithoutCurrentValue.includes(item.value));
    }
  }
};
</script>

<style lang="scss">
.medication-class__select {
  width: 420px;

  & .v-select__selections {
    flex-wrap: nowrap;
  }
}
</style>
